import { useEffect, useState } from "react";
import { environment } from "../../environment";

export interface ShadowRunAgentConfig {
  agentId: string | undefined;
  isConfigured: boolean;
  isLoading: boolean;
}

export function useShadowRunAgentId(): ShadowRunAgentConfig {
  const [agentId, setAgentId] = useState<string | undefined>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    environment()
      .then((env) => {
        if (cancelled) return;
        const configured = env.SHADOW_RUN_AGENT_ID.trim();
        setAgentId(configured || undefined);
      })
      .catch(() => {
        if (!cancelled) setAgentId(undefined);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    agentId,
    isConfigured: !!agentId,
    isLoading,
  };
}
